import EllipsisHoverToggle from '@/components/_common/EllipsisHoverToggle';
import { CustomerAddress } from '@/core/domain/people/CustomerAddresses/CustomerAddresses.types';
import { ColumnsType } from 'antd/lib/table';

export function useAddressColumns<T extends Partial<CustomerAddress>>() {
  const columns: ColumnsType<T> = [
    {
      dataIndex: 'description',
      key: 'description',
      title: 'Descrição',
      width: 200,
      render: (value) => <EllipsisHoverToggle>{value}</EllipsisHoverToggle>,
    },
    {
      dataIndex: 'city',
      key: 'city',
      title: 'Cidade',
      width: 120,
      ellipsis: true,
      render: (_, row) => (
        <EllipsisHoverToggle>{`${row.city || '-'} - ${
          row.state || '-'
        }`}</EllipsisHoverToggle>
      ),
    },
    {
      dataIndex: 'street',
      title: 'Logradouro',
      width: 250,
      ellipsis: true,
      render: (_, row) => (
        <EllipsisHoverToggle>{`${row.street}, ${row.number} - ${row.district}`}</EllipsisHoverToggle>
      ),
    },
    {
      dataIndex: 'main',
      key: 'main',
      title: 'Principal',
      align: 'center',
      width: 80,
      ellipsis: true,
      render: (value) => (value ? 'Sim' : 'Não'),
    },
    {
      dataIndex: 'delivery',
      key: 'delivery',
      title: 'Entrega',
      align: 'center',
      width: 80,
      ellipsis: true,
      render: (value) => (value ? 'Sim' : 'Não'),
    },
  ];

  return { columns };
}
